var TEMPLATE_URL = require('./notes.listitem.html');
angular.module('ikeweb.notes').directive('notesListitem', ['$timeout', 'billingService',
    function($timeout, billingService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATE_URL,
            scope: {
                note: '='
            },
            controller: 'NotesListitemController',
            controllerAs: 'ctrl',
            link: function($scope, $element, attrs, ctrl) {
                var input = $element.find('.NoteListitem-content');

                $scope.focus = function() {
                    $timeout(function() {
                        input[0].focus();
                    });
                };

                $scope.canMakeNote = false;
                billingService.isOnPremium().then(function(isPro) {
                    $scope.canMakeNote = isPro;
                });
            }
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/notes/notes.listitem.directive.js
// module id = 455
// module chunks = 0